module.exports = __webpack_public_path__ + "images/emoji/game_die.639113df4e098eb20f93.png";